module.exports = __webpack_public_path__ + "img/device-7.b456c3d2.png";